import React, { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../utils/localStorage";
import { getStoreCustomerAccountTransaction } from "../../services/StoreCustomerAccount/getStoreCustomerAccountTransaction";
import { postStoreCustomerAccountTransaction, putStoreCustomerAccountTransaction } from "../../services/StoreCustomerAccount/postStoreCustomerAccountTransaction";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import StoreMenu from "../StoreMenu";
import {
  formatDate,
  formatDateWithTime,
} from "../../constants/DateUtil/DateUtil";
import { Button } from "primereact/button";
import ButtonLink from "../../ButtonLink";
import AdminMenu from "../AdminMenu";
import ConfirmTransferAmount from "./ConfirmTransferAmount";
import WalletAmountEditModal from "./WalletAmountEditModal";

const CustomerAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerData, storeCustomerId, storeIdValue } = location.state || {};

  const { storeData, userProfileData, userProfileRole, brandProfileData } =
    getUserData();

  const userRole = userProfileRole;
  const storeId = userRole === "BY_STORE" ? storeData.id : storeIdValue;
  const storeUserId = userProfileData.id;
  let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff
    ? 0
    : 2;
  let brandId = brandProfileData.id;

  const { storeLocalData } = getStoreLocalData();

  const [storeCustomerAccount, setStoreCustomerAccount] = useState([]);
  const [visible, setVisible] = useState(false);
  const [
    storeCustomerAccountPaymentDetails,
    setStoreCustomerAccountPaymentDetails,
  ] = useState([]);
  const handleConfirmAndContinue = () => {
    setVisible(true);
  };

  const [amountValue, setAmountValue] = useState("");
  const [remarkValue, setRemarkValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(null);
  const [apiResMessage, setApiResMessage] = useState("");
  const [isAddButtonPressed, setIsAddButtonPressed] = useState(false);
  const [
    confirmTransferAmountModalVisible,
    setConfirmTransferAmountModalVisible,
  ] = useState(false);
  const [
    walletAmountEditModalVisible,
    setWalletAmountEditModalVisible,
  ] = useState(false);
  const [walletAmountEditSelectedItem, setWalletAmountEditSelectedItem] = useState({})

  const fetchStoreCustomerAccountTransaction = () => {
    getStoreCustomerAccountTransaction(storeCustomerId, storeId)
      .then((response) => {
        if (!response.data.error) {
          const StoreCustomerAccountResponseTransaction = response.data;
          setStoreCustomerAccount(
            StoreCustomerAccountResponseTransaction[0].storeCustomerAccount,
          );
          setStoreCustomerAccountPaymentDetails(
            StoreCustomerAccountResponseTransaction,
          );
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const CreateStoreCustomerAccountTransaction = (data) => {
    postStoreCustomerAccountTransaction(storeCustomerId, storeId, data)
      .then((response) => {
        if (!response.data.error) {
          const CreateStoreCustomerAccountResponse = response.data;
          setApiResStatus(CreateStoreCustomerAccountResponse.status);
          setApiResMessage(CreateStoreCustomerAccountResponse.message);
          setModalVisible(true);
          // Clear the input field
          setAmountValue("");
          setRemarkValue("");
          setIsAddButtonPressed(false);
          fetchStoreCustomerAccountTransaction();
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const EditStoreCustomerAccountTransaction = (data) => {
    putStoreCustomerAccountTransaction(storeCustomerId, storeId, data)
      .then((response) => {
        if (!response.data.error) {
          const CreateStoreCustomerAccountResponse = response.data;
          setApiResStatus(CreateStoreCustomerAccountResponse.status);
          setApiResMessage(CreateStoreCustomerAccountResponse.message);
          setModalVisible(true);
          // Clear the input field
          setAmountValue("");
          setRemarkValue("");
          setIsAddButtonPressed(false);
          fetchStoreCustomerAccountTransaction();
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreCustomerAccountTransaction();
  }, []);

  const receiveDataFromConfirmModal = ({ success }) => {
    if (success) {
      fetchStoreCustomerAccountTransaction();
    }
  };

  const receiveDataFromWalletUpdate = ({success, message}) => {
    if(success) {
      setApiResStatus(success);
      setApiResMessage(message);
      setModalVisible(true);
      // Clear the input field
      setAmountValue("");
      setRemarkValue("");
      setIsAddButtonPressed(false);
      fetchStoreCustomerAccountTransaction();
    }
  }

  const handleAmountChange = (text) => {
    setAmountValue(text);
  };
  const handleRemarkChange = (text) => {
    setRemarkValue(text);
  };

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const onNextButtonPress = () => {
    if (amountValue) {
      // Create a new object with the entered amount
      if (!isAddButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsAddButtonPressed(true);
        const data = {
          transactionType: "Cr",
          payment: {
            receivedBy: storeUserId,
            paidBy: storeCustomerId,
            paymentRefNo: remarkValue,
            amount: amountValue,
            paymentMode: "cash",
          },
        };
        CreateStoreCustomerAccountTransaction(data);
      }
    }
  };

   const handleEditPress = () => {
    if (amountValue) {
      // Create a new object with the entered amount
      if (!isAddButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsAddButtonPressed(true);
        const data = {
          transactionType: "Cr",
          payment: {
            receivedBy: storeUserId,
            paidBy: storeCustomerId,
            paymentRefNo: remarkValue,
            amount: amountValue,
            paymentMode: "cash",
          },
        };
        EditStoreCustomerAccountTransaction(data);
      }
    }
  };

  const handleEdit = (item) => {
    setWalletAmountEditModalVisible(true) 
    setWalletAmountEditSelectedItem(item)
  }

  const CardData = [
    {
      id: 1,
      name: "Balance Amount",
      description:
        storeCustomerAccount.advanceUnit !== undefined
          ? storeLocalData?.currencySymbol +
            " " +
            Number(
              storeCustomerAccount.advanceUnit?.toFixed(
                enabledAmountRoundOffAdmin,
              ),
            )
          : storeLocalData?.currencySymbol + " " + 0,
      // backgroundColor: "Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
      backgroundColor: "#AE3DC0",
    },
    {
      id: 2,
      name: "Subscription Amount",
      description:
        storeCustomerAccount.subscriptionUnit !== undefined
          ? storeLocalData?.currencySymbol +
            " " +
            Number(
              storeCustomerAccount.subscriptionUnit?.toFixed(
                enabledAmountRoundOffAdmin,
              ),
            )
          : storeLocalData?.currencySymbol + " " + 0,
      // backgroundColor: "Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
      backgroundColor: "#35AFAF",
    },
    {
      id: 3,
      name: "Status",
      description: storeCustomerAccount.status === true ? "Active" : "DeActive",
      // backgroundColor: "Laundy_App_Icons_Gifs/Home_Page/Pickup.png",
      backgroundColor: "#30C563",
    },
  ];

  const renderCardItem = () => {
    return CardData.map((item) => (
      <div className="flex-1 my-2 ">
        <div
          className="p-2"
          style={{ backgroundColor: `${item.backgroundColor}` }}
        >
          <p className="text-2xl font-bold text-white text-center">
            {item.name}
          </p>
          <div className="flex flex-row justify-content-center">
            <p className="text-2xl font-bold text-white text-center">
              {item.description}
            </p>
            {/* {userRole === "BY_ADMIN" &&
              item.id === 2 &&
              Number(
                storeCustomerAccount.subscriptionUnit?.toFixed(
                  enabledAmountRoundOffAdmin,
                ),
              ) > 0 && (
                <div
                  onClick={() => setConfirmTransferAmountModalVisible(true)}
                  className="ml-4 cursor-pointer"
                  title="Click Here To Transfer Subscription Amount To Wallet"
                >
                  <img
                    src={"images/transfer.png"}
                    style={{
                      width: 30,
                      height: 30,
                    }}
                  />
                </div>
              )} */}
          </div>
        </div>
      </div>
    ));
  };

  const PaymentStatusColors = {
    Cr: "#30C563",
    Dr: "#AE3DC0",
    DEFAULT: "#000",
  };

  const renderOrderInfoItem = () => {
    return storeCustomerAccountPaymentDetails?.map((item, index) => {
      const paymentStatusColor =
        PaymentStatusColors[item.transactionType] ||
        PaymentStatusColors.DEFAULT;
      const transactionType = item.transactionType === "Cr" ? "+" : "-";
      const formattedDate = formatDateWithTime(item.payment.date);

      return (
        <div className="flex flex-1 mx-2 my-2 gap-2">
          <div
            className="p-2"
            style={{
              backgroundColor: paymentStatusColor,
              borderRadius: 5,
              alignSelf: "center",
            }}
          >
            <p className="text-xl font-semibold text-white">{index + 1}</p>
          </div>

          <div
            className="py-1 px-2 flex-1 flex justify-content-between align-items-center"
            style={{ backgroundColor: paymentStatusColor, borderRadius: 5 }}
          >
            <div>
              <p className="text-xl font-semibold text-white">
                {formattedDate}
              </p>
            </div>

            <div className="flex">
              <p className="text-xl font-semibold text-white">
                {storeLocalData?.currencySymbol} {transactionType}
                {item.payment.amount} {item.processed ? "✓" : "✘"}
              </p>
              {userRole === "BY_ADMIN" &&
                item.transactionType === "Cr" &&
                item.processed && !item.payment.subscriptionPayment && (
                  <div style={{ marginLeft: 10, cursor: "pointer" }} onClick={() => handleEdit(item)}>
                  <img
                    src={"images/pen.png"}
                    style={{
                      width: 25,
                      height: 25,
                    }}
                  />
                  </div>
                )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/WalletLedgerSelection", {
                      state: {
                        customerData: customerData,
                        storeCustomerId: storeCustomerId,
                        storeId: storeIdValue,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Wallet Account
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-1 mx-3 my-3 gap-3">
          <div className="flex-1 flex-row align-items-center">
            {renderCardItem()}
          </div>

          {userRole === "BY_STORE" && (
            <div
              className="  surface-0"
              style={{ width: 3, "--surface-0": "#EAEFF5" }}
            ></div>
          )}

          {userRole === "BY_STORE" && (
            <div className="flex-1 my-2 flex flex-column justify-content-center align-items-center">
              <div className="flex-1 w-full my-1">
                <InputText
                  value={amountValue}
                  onChange={(e) => handleAmountChange(e.target.value)}
                  keyboardType="numeric"
                  placeholder="Add Balance *"
                  className="w-full text-xl border-round-xl shadow-2"
                />
              </div>
              <div className="flex-1 w-full my-1">
                <InputText
                  value={remarkValue}
                  onChange={(e) => handleRemarkChange(e.target.value)}
                  placeholder="Reference No./ Remark"
                  className="w-full text-xl border-round-xl shadow-2"
                />
              </div>
              <div className="flex-1 w-full my-1">
                <Button
                  label="ADD"
                  onClick={onNextButtonPress}
                  disabled={isAddButtonPressed}
                  className=" text-2xl w-full border-round-xl border-none cursor-pointer"
                ></Button>
              </div>
            </div>
          )}
        </div>
        <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
          <div className="flex justify-content-between mx-4">
            <div className="py-1">
              <p className=" text-2xl  font-bold ">Transaction History</p>
            </div>
          </div>
        </div>
        <div style={{ overflowY: "auto" }}>{renderOrderInfoItem()}</div>
      </div>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={apiResStatus === true ? "success" : false}
        text={apiResMessage}
      />
      {userRole === "BY_STORE" ? (
        <StoreMenu setVisible={setVisible} visible={visible} />
      ) : (
        <AdminMenu setVisible={setVisible} visible={visible} />
      )}
      <ButtonLink />
      <ConfirmTransferAmount
        setConfirmTransferAmountModalVisible={
          setConfirmTransferAmountModalVisible
        }
        confirmTransferAmountModalVisible={confirmTransferAmountModalVisible}
        confirmTransferAmount={Number(
          storeCustomerAccount.subscriptionUnit?.toFixed(
            enabledAmountRoundOffAdmin,
          ),
        )}
        sendDataToConfirmTransferAmount={receiveDataFromConfirmModal}
        storeLocalData={storeLocalData}
        brandId={brandId}
        storeCustomerId={storeCustomerId}
      />
      <WalletAmountEditModal
        setWalletAmountEditModalVisible={
          setWalletAmountEditModalVisible
        }
        walletAmountEditModalVisible={walletAmountEditModalVisible}
        walletAmountEditSelectedItem={walletAmountEditSelectedItem}
        sendDataToWalletAmountEdit={receiveDataFromWalletUpdate}
        storeLocalData={storeLocalData}
        brandId={brandId}
        storeCustomerId={storeCustomerId}
        storeUserId={storeUserId}
        storeId={storeId}
      />


    </div>
  );
};

export default CustomerAccount;
